import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// importing stylesheets:
import "./css/App.css";
import "./css/variables.css";
import "./css/animations.css";

// Importing pages
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Projects from "./pages/projects/Projects";
import Devlog from "./pages/devlog/Devlog";
import Contact from "./pages/contact/Contact";

// Importing Global Components
import Layout from "./components/Layout/Layout";
import Firefly from "./components/Firefly/Firefly";

const getStoredTheme = () => {
  try {
    const storedTheme = window.localStorage.getItem("theme");
    return storedTheme === "light" || storedTheme === "dark"
      ? storedTheme
      : null;
  } catch (error) {
    return null;
  }
};

// Define App component
const App = () => {
  // Set the initial state for the page title, using useState hook
  const [pageTitle, setPageTitle] = useState(["Home", " Page"]);
  const [theme, setTheme] = useState(() => getStoredTheme() || "dark");

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const handleThemeToggle = () => {
    const nextTheme = theme === "light" ? "dark" : "light";
    setTheme(nextTheme);
    try {
      window.localStorage.setItem("theme", nextTheme);
    } catch (error) {
      // Theme state still works when browser storage is unavailable.
    }
  };

  // get route location information:
  const location = useLocation();

  return (
    // Render main app container
    <section className="app-container">
      {/* Background Animation using css */}
      <Firefly />
      {/* Use BrowserRouter component to set up the router */}
      <AnimatePresence>
        {/* Use Routes component to define the routes */}
        <Routes location={location} key={location.key}>
          {/* Wrap all the routes with the Layout component */}
          <Route
            path="/"
            element={
              <Layout
                pageTitle={pageTitle}
                theme={theme}
                onThemeToggle={handleThemeToggle}
              />
            }
          >
            {/* Define the Home page route */}
            <Route path="/" element={<Home setPageTitle={setPageTitle} />} />
            {/* Define the About page route */}
            <Route
              path="/about"
              element={<About setPageTitle={setPageTitle} />}
            />
            {/* Define the Projects page route */}
            <Route
              path="/projects"
              element={<Projects setPageTitle={setPageTitle} />}
            />
            {/* Define the Devlog page route */}
            <Route
              path="/devlog"
              element={<Devlog setPageTitle={setPageTitle} />}
            />
            {/* Define the Contact page route */}
            <Route
              path="/contact"
              element={<Contact setPageTitle={setPageTitle} />}
            />

            {/* handling invalid paths */}
            <Route path="*" element={<h1>error 404: page not found!!</h1>} />
          </Route>
        </Routes>
      </AnimatePresence>
    </section>
  );
};

export default App;
